import { Pipe, PipeTransform } from '@angular/core';
import { AbstractControl, FormControl, Validators } from '@angular/forms';

@Pipe({
  name: 'isControlRequired',
  standalone: false
})
export class IsControlRequiredPipe implements PipeTransform {
  transform(formControl?: AbstractControl): boolean {
    if (!formControl) {
      return false;
    }

    // First check using hasValidator for direct validators
    if (formControl.hasValidator(Validators.required) ||
        formControl.hasValidator(Validators.requiredTrue)) {
      return true;
    }

    // For custom validators that may wrap Validators.required,
    // test with an empty control to see if it produces a required error
    if (formControl.validator) {
      const testControl = new FormControl(null);
      testControl.setParent(formControl.parent);
      const validationResult = formControl.validator(testControl);
      return Boolean(validationResult?.['required']);
    }

    return false;
  }
}
